import { TRESPONSE_FACTORY_LIST, TRESPONSE_GET_FACTORY_UOM } from '@monorepo/types';

export type TFactoryListState = {
  factoryListingInfo: TRESPONSE_FACTORY_LIST | null;
  factoryUom: TRESPONSE_GET_FACTORY_UOM | null;
};

export const TFactoryListInfoActionType = {
  GetFactoryList: 'GET_FACTORY_LIST' as const,
  GetFactoryListSuccess: 'GET_FACTORY_LIST_SUCCESS' as const,
  GetFactoryListFailure: 'GET_FACTORY_LIST_FAILURE' as const,
  AllocateProductTypesToFactories: 'ALLOCATE_PRODUCT_TYPES_TO_FACTORIES' as const,
  AllocateProductTypesToFactoriesSuccess: 'ALLOCATE_PRODUCT_TYPES_TO_FACTORIES_SUCCESS' as const,
  AllocateProductTypesToFactoriesFailure: 'ALLOCATE_PRODUCT_TYPES_TO_FACTORIES_FAILURE' as const,
  GetFactoryUom: 'GET_FACTORY_UOM' as const,
  GetFactoryUomSuccess: 'GET_FACTORY_UOM_SUCCESS' as const,
  UpdateFactoryUom: 'UPDATE_FACTORY_UOM' as const,
  UpdateFactoryUomSuccess: 'UPDATE__FACTORY_UOM_SUCCESS' as const,
};
